import React from 'react';
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import Title from './Title'
import Button from './Button';
import Input from './Input';

const Container = styled.div`
    text-align: center;
    width: 380px;
    margin: 0 20px;
    padding: 35px 50px;

    border-radius: 10px;  
    opacity: 1;
    background: #FFFFFF80 0% 0% no-repeat padding-box;
    box-shadow: inset 0px 3px 6px #00000029;
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);

    @media only screen and (min-width: 768px) {
        padding: 50px 135px;
    }
`;

const Text = styled.p`
    font-size: 12px;
    margin: -25px 0 30px 0;

    @media only screen and (min-width: 768px) {
        font-size: 18px;
    }

    @media only screen and (min-width: 1200px) {
        font-size: 20px;
    }
`;


const InputQuestion = ({ imgSrc, title, text, inputValue, setInputState, placeholder, path }) => {
    return (

        <Container>
            <img src={imgSrc} alt={title} width={190} />
            <Title title={title} />
            <Text>{text}</Text>
            <Input
                inputValue={inputValue}
                setInputState={setInputState}
                placeholder={placeholder}
            />
            <Link to={path}>
                <Button text="Next" />
            </Link>
        </Container>

    )
}

export default InputQuestion;